import React from "react";

// Components
import CaseIncidentsSubmit from "../CaseIncidentsSubmit/CaseIncidentsSubmit";
import SectionWrapper from "../../components/SectionWrapper";
import ShareWithOptions from "./ShareWithOptions";
import ShareWithProvider, { useShareWith } from "./ShareWithProvider";

const PageContent = () => {
  const { recipient } = useShareWith();

  return recipient ? (
    <CaseIncidentsSubmit recipient={recipient} />
  ) : (
    <ShareWithOptions />
  );
};

const ShareWithPage = () => (
  <SectionWrapper>
    <ShareWithProvider>
      <PageContent />
    </ShareWithProvider>
  </SectionWrapper>
);

export default ShareWithPage;
